import 'depop/assets/stores/app-store-en.svg';
import 'depop/assets/stores/app-store-it.svg';
import 'depop/assets/stores/google-play-en.svg';
import 'depop/assets/stores/google-play-it.svg';
import 'depop/assets/devices/android@2x.png';
import 'depop/assets/devices/iphone@2x.png';
import 'depop/assets/taglines/tagline_web_mobile_en.svg';
import 'depop/assets/taglines/tagline_web_mobile_it.svg';
import 'depop/assets/taglines/tagline_web_desktop_en.svg';
import 'depop/assets/taglines/tagline_web_desktop_it.svg';
import 'depop/assets/video/ic_play.svg';
import 'depop/assets/video/play_broken.svg';
import 'depop/assets/video/ic_volume_off.svg';
import 'depop/assets/video/ic_volume_on.svg';
import 'depop/assets/video/ic_video_normal.svg';
import 'depop/assets/video/rewind.svg';



// WEBPACK FOOTER //
// ../src/client/utils/initImageAssets.js